import { ThemeProvider } from "@emotion/react";
import { Box, BoxProps, Tabs, TabsProps } from "@mui/material";
import { STabTheme } from "components/styles";
import { forwardRef, RefCallback } from "react";
import { UseControllerProps } from "react-hook-form";

export type STabProps = Pick<UseControllerProps, "name"> &
  Partial<Pick<BoxProps, "gridColumn" | "gridRow">> &
  Partial<TabsProps>;

export const STab = forwardRef<HTMLElement, STabProps>(
  ({ gridColumn, gridRow, ...props }, ref) => (
    <ThemeProvider theme={STabTheme}>
      <Box display="grid" gridColumn={gridColumn} gridRow={gridRow}>
        <Tabs
          ref={(element: any) => {
            (ref as RefCallback<HTMLElement>)(element);
          }}
          indicatorColor="primary"
          textColor="primary"
          variant="standard"
          value={props.value}
          onChange={props.onChange}
        >
          {props.children}
        </Tabs>
      </Box>
    </ThemeProvider>
  )
);
